import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-equipment',
  templateUrl: './request-equipment.component.html',
  styleUrls: ['./request-equipment.component.scss']
})
export class RequestEquipmentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
